import * as tslib_1 from "tslib";
import getAllTableViewsContainingItemsForFolder from '../utils/getAllTableViewsContainingItemsForFolder';
import flagItemsStoreUpdate from 'owa-mail-actions/lib/triage/flagItemsStoreUpdate';
import { mutator } from 'satcheljs';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
export default mutator(flagItemsStoreUpdate, function (actionMessage) {
    var e_1, _a, e_2, _b;
    // Need to check all tables for the given folder
    var tableViews = getAllTableViewsContainingItemsForFolder(actionMessage.parentFolderId, true /* shouldIncludeSearchTable */);
    try {
        for (var tableViews_1 = tslib_1.__values(tableViews), tableViews_1_1 = tableViews_1.next(); !tableViews_1_1.done; tableViews_1_1 = tableViews_1.next()) {
            var tableView = tableViews_1_1.value;
            // We only care about updating roll up status in conversation table
            // Item level updates are handled separately in mail store mutator
            if (tableView.tableQuery.listViewType == 0 /* Conversation */) {
                try {
                    for (var _c = tslib_1.__values(actionMessage.itemContexts), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var itemContext = _d.value;
                        rollupFlagStatusChangeOnConversation(itemContext, tableView, actionMessage.flagStatusToSet);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tableViews_1_1 && !tableViews_1_1.done && (_a = tableViews_1.return)) _a.call(tableViews_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
});
function rollupFlagStatusChangeOnConversation(itemContext, tableView, flagStatusToSet) {
    var e_3, _a;
    var rowKeys = getRowKeysFromRowIds([itemContext.conversationId], tableView);
    try {
        for (var rowKeys_1 = tslib_1.__values(rowKeys), rowKeys_1_1 = rowKeys_1.next(); !rowKeys_1_1.done; rowKeys_1_1 = rowKeys_1.next()) {
            var rowKey = rowKeys_1_1.value;
            var tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);
            // Roll up the update to the conversation. Some notes here:
            // 1. If the conversation was not flagged and a local item in it was flagged,
            // we know the conversation should be flagged.
            // 2. If the conversation was flagged and a local item in it was unflagged,
            // we cannot know for certain that the conversation doesn't have any more local
            // flagged items. However, this is the most common case, so we'll optimistically clear the
            // flag status on the conversation. If we were wrong, notifications will correct us
            tableConversationRelation.flagStatus = flagStatusToSet;
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (rowKeys_1_1 && !rowKeys_1_1.done && (_a = rowKeys_1.return)) _a.call(rowKeys_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
}
//# sourceMappingURL=flagItemsStoreUpdateMutator.js.map